import { literal, object, string } from "superstruct";

import type { PathParamsBase } from "../endpoint/Endpoint.js";
import Endpoint from "../endpoint/Endpoint.js";
import EndpointRouter from "../endpoint/EndpointRouter.js";
import { BriefSerializedSchema } from "../models/Brief.js";
import { type User } from "../models/User.js";

export default function buildBriefRouter(base: EndpointRouter<PathParamsBase, { user: User }>) {
    const router = base.addRouter(new EndpointRouter());

    const endpoints = {
        getBriefEndpoint: router.addEndpoint(
            new Endpoint()
                .setMethod("GET")
                .setPath("/briefs/:brief", object({ brief: string() }))
                .setResultParser(BriefSerializedSchema),
        ),
        updateBriefEndpoint: router.addEndpoint(
            new Endpoint()
                .setMethod("PUT")
                .setPath("/briefs/:brief", object({ brief: string() }))
                .setResultParser(literal(null))
                .setBodySchema(BriefSerializedSchema),
        ),
    };

    return { router, endpoints };
}
